














































































































import { Prop, Model, Watch, Vue, Component } from 'vue-property-decorator';
import { Language, InternationalizedField } from '../api/common';
import { replaceAll } from '../util/replace-all';
import Modal from '@/components/Modal.vue';
import { getDictionary } from '@/api/dictionary';
import { isEmpty, split } from 'lodash';

@Component({
  components: {
    modal: Modal
  }
})
export default class FieldInternational extends Vue {
  @Model('update') public field!: InternationalizedField<string>;
  @Prop({ type: String }) public placeholder!: string;
  @Prop({ type: Boolean, default: false }) public big: boolean;
  @Prop({ type: Boolean, default: false }) public html: boolean;
  @Prop({ type: Boolean, default: false }) public firstInput: boolean;
  @Prop({ type: Boolean, default: false }) public disabled: boolean;
  @Prop({ type: String, default: '' }) public sentence: string;
  @Prop({ type: Boolean, default: false }) public dictionary: boolean;
  @Prop() public config: any = {
    attribution: false,
    placeholderText: this.placeholder,
    charCounterCount: false,
    toolbarButtons: [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      'subscript',
      'superscript',
      'fontSize',
      'textColor',
      '|',
      'color',
      '|',
      'align',
      'quote',
      'insertTable',
      'insertImage',
      'insertVideo',
      '|',
      'emoticons',
      'specialCharacters'
    ],
    height: 500,
    imageUpload: false
  };

  public languageOptions: object[] = null;
  public language: string = Language.DEFAULT;
  public text: string = '';
  public showModal: boolean = false;

  public definitionOptions: object[] = [];
  public isLoadingDefinition = false;
  public selectedDefinition: string = '';
  public error: string = '1234';

  public beforeMount() {
    this.loadLanguageOptions();
    this.setText();
  }

  public mounted() {
    if (this.firstInput) {
      (this.$refs.input as HTMLElement).focus();
    }
  }

  public async openModal() {
    this.showModal = true;

    if (isEmpty(this.sentence)) {
      this.error = 'Sentence is empty';
      return;
    }

    const parts = this.sentence.trim().split(' ');
    if (parts.length > 2) {
      this.error = 'Dictionary support only for single word';
      return;
    }

    this.error = '';
    const definitions = await getDictionary(this.sentence);

    if (isEmpty(definitions)) {
      this.error = 'Loaded empty data from server';
      return;
    }

    this.definitionOptions = definitions.map((item, index) => ({
      key: index.toString(),
      value: item,
      text: item
    }));
  }

  public closeModal() {
    this.showModal = false;
    this.error = '';
  }

  // loads available languages for selection
  public loadLanguageOptions() {
    this.languageOptions = [];
    for (const option of Language.LIST) {
      this.languageOptions.push({
        key: option,
        flag: Language.flagOf(option),
        value: option,
        text: Language.codeOf(option)
      });
    }
  }

  public saveClicked() {
    this.showModal = false;
    this.error = '';
    this.text = this.selectedDefinition;
  }

  @Watch('sentence')
  public onSentenceChange() {
    console.log(this.sentence);
  }

  @Watch('field')
  @Watch('language')
  public setText() {
    this.text = '';
    const text = this.field.get(this.language);
    if (text) {
      this.text = text;
    }
  }

  @Watch('text')
  public setValue() {
    let sanitizedText = replaceAll(
      'Froala Editor',
      '',
      replaceAll('Powered by', '', this.text)
    );

    const copyrightIndex = sanitizedText.indexOf('<p data-f-id="pbf"');
    if (copyrightIndex >= 0) {
      sanitizedText = sanitizedText.slice(0, copyrightIndex);
    }

    if (this.html && !sanitizedText.startsWith("<div class='wrapper'>")) {
      sanitizedText = "<div class='wrapper'>" + sanitizedText + '</div>';
    }

    this.field.set(this.language, sanitizedText);
    this.$emit('update', this.field);
  }
}
